import { BASE_URL } from "../../../../Utilities/APIs"

function Image({ imgLink, imgAlt }) {
  return (
    imgLink &&
    <img
      src={BASE_URL + imgLink.slice(6, imgLink.length)}
      alt={imgAlt}
    />
  )
}

export default Image